import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Policy extends Component {
	render() {
		return (
			<>
				<div className="page-content bg-white">
					<div className="banner-wraper">
						<div className="page-banner" style={{ backgroundColor: '#f4f4f4', padding: '50px 0' }}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>Privacy Policy</h1>
									<p className="mb-0">How we collect, use, and protect patient and visitor information.</p>
								</div>
							</div>
						</div>
					</div>

					<section className="section-area section-sp1">
						<div className="container">
							<div className="row">
								<div className="col-lg-12">
									<p><strong>Last Updated:</strong> July 1st, 2026</p>
									<p>This website is operated by Family EcoDental, LLC, doing business as Family Eco Dental.</p>

									<h3>Overview</h3>
									<p>
										We respect your privacy and are committed to protecting your personal information. This Privacy Policy explains
										how we collect, use, disclose, and safeguard information when you visit our website, request appointments,
										contact our office, or receive care-related communications.
									</p>
									<p>
										This policy applies to information collected through this website and related communications. It does not
										replace any notice of privacy practices provided to you under applicable healthcare privacy laws.
									</p>

									<h3>Information We Collect</h3>
									<p>Depending on your interactions with us, we may collect the following categories of information:</p>
									<ul>
										<li>Contact details, such as your name, phone number, email address, and mailing address.</li>
										<li>Appointment-related information, including requested services, preferred times, and follow-up notes.</li>
										<li>Communication records, such as web form submissions, emails, and call or text preferences.</li>
										<li>Technical usage data associated with website visits, such as browser type, pages visited, and referring source.</li>
										<li>Any other information you choose to provide to us directly.</li>
									</ul>

									<h3>How We Use Information</h3>
									<p>We use information for legitimate business and patient care purposes, including to:</p>
									<ul>
										<li>Schedule and manage appointments and patient communications.</li>
										<li>Respond to questions, service requests, and support needs.</li>
										<li>Coordinate treatment follow-up and care-related reminders.</li>
										<li>Maintain records and comply with legal, regulatory, and professional obligations.</li>
										<li>Improve our website, services, and patient experience.</li>
									</ul>

									<h3>Text Message Communications (SMS Program)</h3>
									<p><strong>Consent.</strong> With your express consent, we may send text messages to your mobile phone number for:</p>
									<ul>
										<li>Appointment reminders and confirmations</li>
										<li>Treatment follow-up instructions</li>
										<li>Important health and care updates related to your treatment</li>
										<li>Prescription and care reminders</li>
									</ul>
									<p><strong>Message Frequency.</strong> Message frequency varies but typically up to 4 messages per month. You may receive additional messages during active treatment periods.</p>
									<p><strong>Costs.</strong> Message and data rates may apply as determined by your mobile carrier. We do not charge for text messages, but your carrier's standard messaging rates will apply.</p>
									<p><strong>Opt-Out.</strong> You can opt out of text messages at any time by:</p>
									<ul>
										<li>Replying <strong>STOP</strong> to any text message</li>
										<li>Calling our office at 201-330-2837</li>
										<li>Requesting removal during your next visit</li>
										<li>Emailing us at team@familyecodental.com</li>
									</ul>
									<p><strong>Help.</strong> For help with text messages, reply <strong>HELP</strong> to any message or contact our office directly.</p>
									<p><strong>Privacy.</strong> Your mobile phone number and text message preferences are kept confidential and will not be shared with third parties for marketing purposes.</p>

									<h3>Cookies and Analytics</h3>
									<p>
										Our website may use cookies or similar technologies for core functionality and site performance.
										You can control cookies through your browser settings, though disabling certain cookies may affect
										website functionality.
									</p>

									<h3>How We Share Information</h3>
									<p>We may disclose information as reasonably necessary to:</p>
									<ul>
										<li>Provide requested services and support patient care coordination.</li>
										<li>Support website and business operations through vendors or service providers.</li>
										<li>Comply with legal requirements, lawful requests, or professional obligations.</li>
										<li>Protect the rights, safety, and security of patients, staff, and our practice.</li>
									</ul>

									<h3>Data Security</h3>
									<p>
										We use safeguards that are intended to protect personal information.
										No method of transmission over the internet or electronic storage is completely secure.
									</p>

									<h3>Data Retention</h3>
									<p>
										We retain personal information for as long as reasonably necessary for the purposes described in this policy,
										including to provide services, maintain required records, resolve disputes, and comply with legal or
										regulatory obligations. Retention periods vary depending on the type of information and applicable law.
									</p>

									<h3>Your Rights and Choices</h3>
									<p>Subject to applicable law, you may have rights to:</p>
									<ul>
										<li>Request access to certain personal information we hold about you.</li>
										<li>Request correction of inaccurate or incomplete information.</li>
										<li>Request deletion of information when permitted by law.</li>
										<li>Object to or request limits on certain processing activities.</li>
										<li>Withdraw consent for optional communications at any time.</li>
									</ul>
									<p>
										To exercise rights or make a privacy request, contact us using the information below. We may need to verify
										your identity before processing certain requests.
									</p>

									<h3>Children's Privacy</h3>
									<p>
										Our website is intended for a general audience and is not directed to children under 13.
										If you believe a child has submitted personal information, contact us and we will review and address the issue.
									</p>

									<h3>Third-Party Links</h3>
									<p>
										Our website may contain links to third-party websites. We are not responsible for the privacy or content
										practices of third-party sites, and we encourage you to review their policies before providing information.
									</p>

									<h3>Policy Changes</h3>
									<p>
										We may update this Privacy Policy from time to time. Changes become effective when posted to this page.
										The Last Updated date above reflects the most recent revision.
									</p>

									<h3>Contact Us</h3>
									<p>If you have questions about this Privacy Policy or our privacy practices, contact us at:</p>
									<ul>
										<li>Phone: 201-330-2837</li>
										<li>Email: team@familyecodental.com</li>
										<li>Mail: 407 39th Street, Suite 401, Union City, NJ 07087</li>
									</ul>
									<p>
										For terms governing use of this website and services, please review our <Link to="/terms">Terms of Service</Link>.
									</p>
								</div>
							</div>
						</div>
					</section>
				</div>
			</>
		);
	}
}

export default Policy;
